<script setup lang="ts">
import { PriceGuaranteeModal } from '@apps/main/new-desktop/modules/priceGuarantee';

import { HotelDetailsModalType } from '../models';
import { PriceBreakdownModal } from '../../priceBreakdownModal';
import {
  useHotelDetailsDescriptionStore,
  useHotelDetailsModalsStore,
} from '../stores';

import AmenitiesModal from './modals/AmenitiesModal.vue';
import FullHotelDetailsDescriptionModal from './modals/FullHotelDetailsDescriptionModal.vue';
import FullDestinationDescriptionModal from './modals/FullDestinationDescriptionModal.vue';

const hotelDetailsModalsStore = useHotelDetailsModalsStore();
const hotelDetailsDescriptionStore = useHotelDetailsDescriptionStore();
</script>

<template>
  <AmenitiesModal
    v-if="
      hotelDetailsModalsStore.hotelDetailsModalType ===
        HotelDetailsModalType.Amenitites &&
      hotelDetailsDescriptionStore.fullAmenitiesGroups
    "
    :amenities-groups="hotelDetailsDescriptionStore.fullAmenitiesGroups"
    @close="hotelDetailsModalsStore.closeModal"
  />
  <FullHotelDetailsDescriptionModal
    v-if="
      hotelDetailsModalsStore.hotelDetailsModalType ===
      HotelDetailsModalType.FullHotelDetailsDescription
    "
    @close="hotelDetailsModalsStore.closeModal"
  />
  <FullDestinationDescriptionModal
    v-if="
      hotelDetailsModalsStore.hotelDetailsModalType ===
        HotelDetailsModalType.FullDestinationDescription &&
      hotelDetailsModalsStore.destinationInformation
    "
    :destination-information="hotelDetailsModalsStore.destinationInformation"
    @close="hotelDetailsModalsStore.closeModal"
  />
  <PriceBreakdownModal
    v-if="
      hotelDetailsModalsStore.hotelDetailsModalType ===
        HotelDetailsModalType.PriceBreakdown &&
      hotelDetailsModalsStore.moreInformationModalFor
    "
    :data="hotelDetailsModalsStore.moreInformationModalFor"
    @close="hotelDetailsModalsStore.closeModal"
  />
  <PriceGuaranteeModal
    v-if="
      hotelDetailsModalsStore.hotelDetailsModalType ===
      HotelDetailsModalType.PriceGuarantee
    "
    @close="hotelDetailsModalsStore.closeModal"
  />
</template>
